import { call, put, takeLatest } from 'redux-saga/effects';
import BackendService from 'services/BackendService';
import { commandsEntityActions } from './commandsEntity.slice';
import {
	parseFetchAllRequest,
	parseFetchAllSuccess,
	parseMetadata,
} from './commands.parsers';

function* fetchCommands(action) {
	const payload = action.payload || {};
	yield put(commandsEntityActions.fetchCommandsPending());
	try {
		const requestBody = parseFetchAllRequest(payload);
		const response = yield call(BackendService.searchCommandsProcessing, requestBody);
		const responseData = response?.data || response;
		const data = parseFetchAllSuccess(responseData);
		const metadata = parseMetadata(responseData);
		yield put(commandsEntityActions.fetchCommandsSuccess({ data, metadata, requestParams: payload }));
	} catch (error) {
		yield put(commandsEntityActions.fetchCommandsFailure(error));
	}
}

export default function* watchCommandsSaga() {
	yield takeLatest(commandsEntityActions.fetchCommands, fetchCommands);
}
